import {
  Card,
  CardActionArea,
  CardContent,
  CardProps,
  useTheme
} from '@mui/material'
import { PropsWithChildren } from 'react'

interface Props {
  onClick?: () => void
}

const PopperItem = ({
  onClick,
  children,
  sx
}: Props & PropsWithChildren & CardProps) => {
  const { extraColors } = useTheme()

  return (
    <Card
      elevation={0}
      sx={{
        backgroundColor: extraColors.bodyBackground,
        height: '100%',
        '& .MuiCardActionArea-root': {
          height: '100%'
        },
        '& .MuiCardContent-root': {
          padding: 0
        },
        ...sx
      }}
    >
      <CardActionArea onClick={onClick} sx={{ padding: 0 }}>
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          {children}
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default PopperItem
